import React from "react";
import { useNavigate } from "react-router-dom";
import { Col } from "antd";

import CustomRow from "../../../shared/costum-row/costum-row";
import Headline from "../../../components/headline/headline";
import BlogCard from "../../../components/blog-card/blog-card";

import { HEADLINE_ORIENTATION } from "../../../constants/props";
import { routes } from "../../../constants/routes";
import { VIEWS } from "../../../constants/global";
import { BLOG_CONTENT } from "../../../constants/content/pages/blog";

import "./styles.scss";

const Blog = () => {
  const navigate = useNavigate();

  return (
    <div className="Blog-page">
      <div className="Blog-content">
        <Headline
          title={BLOG_CONTENT.headline.title}
          subtitle={BLOG_CONTENT.headline.subtitle}
          orientation={HEADLINE_ORIENTATION.BOTTOM}
        />
        <CustomRow gutter={[0, 80]} className="Blog-cards-container">
          {BLOG_CONTENT.blogPosts.map((post) => (
            <Col span={24} key={post.id}>
              <BlogCard
                title={post.title}
                date={post.date}
                category={post.category}
                author={post.author}
                description={post.description}
                imageSrc={post.imageSrc}
                onClick={() =>
                  navigate(`${routes[VIEWS.BLOG_DETAILS].staticPath}/${post.id}`)
                }
              />
            </Col>
          ))}
        </CustomRow>
      </div>
    </div>
  );
};

export default Blog;
